import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const DataModelsDropdown = ({
  className,
  clearable,
  dataModel,
  entity,
  error,
  fluid,
  onChange,
  readStatus,
  showHidden = false,
  size = 'large',
}) => {
  const intl = useIntl();
  const state = Selectors.useDataModelsDropdown({ dataModel, showHidden });
  Fetch.useFetchDataModels({ category: 'all' }, state.readStatus);

  const listItems = state.dataModels.map((item) => ({
    key: `data_model_${item.code}`,
    text: item.name,
    value: item.code,
    disabled: !item.enabled,
  }));

  return (
    <Dropdown
      className={className}
      clearable={clearable}
      disabled={!!(error || state.error)}
      fluid={fluid}
      id="data_model_dropdown"
      loading={[state.readStatus, readStatus].includes(states.PENDING)}
      onChange={(e, { value }) => onChange({ dataModelCode: value })}
      options={listItems}
      placeholder={intl.formatMessage({ id: `dataset.${entity}.datamodel.dropdown.label` })}
      selection
      size={size}
      value={dataModel}
    />
  );
};

export default DataModelsDropdown;
